<template>
    <div class="locationSelectBox">
        <span>经营区域选择:</span>
        <div>
            <el-button :type="item.label == city_location.label ? 'primary' : 'default'" v-for="item in cityOptions" :key="item.label" @click="change_localtion(item)">{{item.label}}</el-button>
            <!-- <el-select v-model="provinceValue" placeholder="请选择"  >
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <el-select :value="cityValue" @change="change_localtion" placeholder="请选择" >
                <el-option
                v-for="item in cityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select> -->
        </div>
    </div>
</template>
<style lang="scss">
  .changelocation-box{
    width: 730px !important;
    vertical-align: baseline;
    .el-message-box__title{
      padding: 15px;
      font-size: 24px;
      font-weight: 500;
      color: #333333;
    }
    .el-message-box__content{
      padding: 0 17px 0 30px;
    }
    .locationSelectBox{
        &>span{
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }
        &>div .el-select:first-child{
            margin-right: 20px;
        }
    }
  }
</style>
<style lang="scss" scoped>
    .locationSelectBox{
        display: flex;
        height: 70px;
        align-items: stretch;
        &>span{
            display: flex;
            align-items: center;
            width: 20%;
        }
        &>div{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
</style>
<script>
import Vue from 'vue'
import {mapGetters, mapMutations} from 'vuex'
import { listSearchMixin } from "@/config/mixin";
import api from '@/api'
export default {
    mixins: [listSearchMixin],
    name:'changeLocation',
    props:{
        city_location:{
            default:() => {
                return {value:'BASE',label:'保山'}
            }
        },
        setLocation:{
            default:()=>{}
        },
        finish:{
            default:()=>{}
        }
    },
    data(){
        return{
            options: [{
                value: '云南省',
                label: '云南省'
            }],
            provinceValue: '云南省',
            cityOptions: [
            ],
            cityValue:this.$props.city_location
        }
    },
    mounted() {
        this.getShopAreaData();
    },
    methods:{
        change_localtion(item){
            if(item.url){
                window.open(item.url,"_blank");
            }else{
                this.cityValue = item.label;
                this.$props.setLocation(item);
                this.$props.finish();
            }
        },
        getShopAreaData(){
            let params = {
                url: api.supportArea,
                method: "GET"
            };
            this.sendReq(params, (res) => {
                if (res.code == 200){
                    this.cityOptions = [];
                    res.data.forEach(d => {
                        this.cityOptions.push({
                            label: d.area,
                            value: d.areaCode,
                            url: ''
                        });
                    });
                    this.cityOptions.push({
                        value: 'BASE',
                        label: '兰坪',
                        url:'https://bulk.lpszgyl.com/'
                    })
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/base_b2c/changeLocation.vue